import { inject, Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HelperService } from './helper.service';
import { TPageDataWithHome } from '@shared/constants/models.const';
import { STORE_SEARCH_INDEX } from '@shared/constants/enums.const';

const adobe_DataIndex = 'digitalData';
const adobe_satelliteIndex = '_satellite';
const adobe_actionIndex = 'page_load';
const countNames: any = {
  0: 'primary',
  1: 'secondary',
  2: 'tertiary',
  3: 'quaternary',
  4: 'quinary',
  5: 'senary',
  6: 'septenary',
  7: 'octonary',
  8: 'nonary',
  9: 'denary',
};


@Injectable({
  providedIn: 'root',
})
export class AdobeAnalyticsService {
  private readonly apiConfig: ApiConfig = inject(ApiConfig);
  private readonly HELPER: HelperService = inject(HelperService);

  private get digitalData() {
    // @ts-ignore
    return window[adobe_DataIndex];
  };

  private set digitalData(value) {
    // @ts-ignore
    window[adobe_DataIndex] = value;
  };

  init(): void {
    const adobe = this.apiConfig.config.adobeAnalytics;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = adobe.src;
    document.head.appendChild(script);

    this.HELPER.$pageData.subscribe(data => {
      if (data) {
        this.contentLoaded(data);
      }
    });

    // @ts-ignore
    this.digitalData = {
      page: {
        pageInfo: {
          pageName: 'page name',
          pageCountry: 'country',
        },
      },
      category: {
        primaryCategory: 'франшиза',
        secondaryCategory: 'тип документа/фолдера',
        tertiaryCategory: 'оставшийся путь',
      },
      search: {
        searchTerms: 'search terms',
        resultsCount: 'number of results returned',
        resultsPosition: 'position of clicked result',
        resultsTitle: 'title of clicked result',
      },
      content: {
        contentID: 'content ID',
        contentType: 'content type',
        contentTitle: 'content title',
      },

    };
  }


  getPageInfo(data?: TPageDataWithHome) {
    return {
      pageInfo: {
        pageName: data?.title || 'Home page',
        pageCountry: `${this.HELPER.currentFrItem?.country}/ ${this.HELPER.currentFrItem?.language}`,
      },
    };
  }

  getContentInfo(data: TPageDataWithHome) {
    return {
      contentID: data.id,
      contentType: data.folderType || data.type,
      contentTitle: data.title,
    };
  }

  contentLoaded(data: any) {
    this.digitalData = {
      page: this.getPageInfo(data),
    };

    this.digitalData.category = this.getCategoryInfo();
    if (data && data.id) this.digitalData.content = this.getContentInfo(data);
    if ((data && data.searchTerms) || localStorage.getItem(STORE_SEARCH_INDEX)) {
      this.digitalData.search = this.getSearchInfo(data);
    }
    this.pageLoad();
  }

  getCategoryInfo() {
    const category: any = {};
    const urlArr = this.HELPER.getUrlArray();

    if (urlArr.length) {
      urlArr.forEach((item, index: number) => {
        if (index < 9) {
          category[countNames[index]] = item;
        }
      });
    }

    if (urlArr.length > 9) category[countNames[9]] = urlArr.slice(9).join('/');
    return category;
  }

  getSearchInfo(data: any) {
    let searchInfo: any = {};
    if (data && data.searchTerms) {
      searchInfo.searchTerms = data.searchTerms;
      searchInfo.resultsCount = data.resultsCount;
    } else {
      searchInfo = JSON.parse(<string> localStorage.getItem(STORE_SEARCH_INDEX));
    }

    localStorage.removeItem(STORE_SEARCH_INDEX);
    return searchInfo;

  }

  pageLoad(log = false) {
    setTimeout(() => {
      if (log) {
        console.log('pageLoad >> ', this.digitalData);
      }
      // @ts-ignore
      if (window[adobe_satelliteIndex]) {
        // @ts-ignore
        window[adobe_satelliteIndex].track(adobe_actionIndex);
      }

    }, 50);

  }

}
